import { render } from "./HavaKurutucusuKartusu.vue?vue&type=template&id=c28b9734"
import script from "./HavaKurutucusuKartusu.vue?vue&type=script&lang=js"
export * from "./HavaKurutucusuKartusu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__